import React, { useCallback } from 'react';
import classnames from 'classnames';
import Icon from '../../Icon';
import PropTypes from 'prop-types';

const OfferPagePromoGalleryLandings = ({ data = [], onClickShowLandingPreview, onClickShowConstructor, ...props }) => {
    const getClass = useCallback((item) => {
        return classnames({
            'gallery-banners__item': true,
            'gallery-banners__item_vertical': item.proportion === 'vertical',
            'gallery-banners__item_horizontal': item.proportion === 'horizontal',
            'gallery-banners__item_small': item.small
        });
    }, []);

    const onShowLandingPreview = useCallback((event) => {
        const index = event.target.closest('.gallery-banners__control-wrapper').getAttribute('data-index');

        if (onClickShowLandingPreview) {
            onClickShowLandingPreview(data[index]);
        }
    }, [data, onClickShowLandingPreview]);

    const onShowConstructor = useCallback((event) => {
        const index = event.target.closest('.gallery-banners__control-wrapper').getAttribute('data-index');

        if (onClickShowConstructor) {
            onClickShowConstructor(data[index]);
        }
    }, [data, onClickShowConstructor]);

    return (
        <div className="gallery-banners">
            {(data || []).map((item, i) => (
                <div className={getClass(item)} key={item.id}>
                    <div className="gallery-banners__wrapper">
                        <img className="gallery-banners__image" src={item.preview_url} alt={item.type} />
                        <div className="gallery-banners__title">{item.width} x {item.height}, {item.type}</div>
                        <div className="gallery-banners__control">
                            <div className="gallery-banners__control-wrapper" data-index={i}>
                                <button
                                    className="gallery-banners__control-item btn-empty"
                                    onClick={onShowLandingPreview}
                                >
                                    <Icon name="fa-eye" />
                                </button>
                                <button
                                    className="gallery-banners__control-item btn-empty"
                                    onClick={onShowConstructor}
                                >
                                    <Icon name="fa-code" />
                                </button>
                                <a
                                    className="gallery-banners__control-item"
                                    href={item.download_url}
                                    target="_blank"
                                    download
                                >
                                    <Icon name="fa-cloud-download" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

OfferPagePromoGalleryLandings.propTypes = {
    data: PropTypes.array,
    onClickShowLandingPreview: PropTypes.func,
    onClickShowConstructor: PropTypes.func
};

export default OfferPagePromoGalleryLandings;
